/*
 * @Author: zhujiapeng
 * @Date: 2021-01-26 18:53:36
 * @LastEditors: zhujiapeng
 * @LastEditTime: 2021-01-26 18:58:19
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */

import React from 'react';
import { Modal } from 'antd';
import AxiosTS from '../../core/axios';

class FaceImg extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    AxiosTS.Business('public/resource/getResourceUrl', { resourceId: this.props.resourceId }).then((res) => {
      this.setState({
        img: res.result
      });
    });
  }

  render() {
    return <Modal
      visible={true}
      title="考勤照片"
      width={550}
      footer={null}
      className="show-poster-modal"
      onCancel={() => { this.props.cancel() }}
    >
      <img src={this.state.img} style={{ width: '100%' }} />
    </Modal>
  }
}

export default FaceImg;